import * as yup from 'yup'

export const schema = yup.object().shape({
  id: yup.string().nullable(),
  descricao: yup.string().required(),
  atalho: yup.string().required()
})
